import React, { useEffect } from "react";
import "./Mission.css";
import "@fontsource/source-sans-pro";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import MainBanner from "./components/MainBanner/MainBanner";
import List from "./components/List/List";
import { Helmet } from "react-helmet-async";

const Mission = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>
          ISKCON Vijayawada Mission – Spreading Krishna Consciousness
        </title>
        <meta
          name="description"
          content="Discover the mission of ISKCON Vijayawada—to educate, uplift, and inspire through Krishna consciousness, devotional service, and spiritual education."
        />
        <meta
          name="keywords"
          content="ISKCON mission, Krishna consciousness mission, ISKCON goals, devotional service purpose"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="ISKCON Vijayawada Mission – Spreading Krishna Consciousness"
        />
        <meta
          property="og:description"
          content="Discover the mission of ISKCON Vijayawada—to educate, uplift, and inspire through Krishna consciousness, devotional service, and spiritual education."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/mission"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="ISKCON Vijayawada Mission – Spreading Krishna Consciousness"
        />
        <meta
          name="twitter:description"
          content="Discover the mission of ISKCON Vijayawada—to educate, uplift, and inspire through Krishna consciousness, devotional service, and spiritual education."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.iskconvijayawada.org/mission" />
      </Helmet>
      <Header />
      <div className="mission-page md:mt-8">
        <MainBanner />
        <List />
      </div>
      <Footer />
    </>
  );
};

export default Mission;
